import { BudgetCounterProposalSubStatusEnum } from "../../../../enums/budgetCounterProposalStatus";
import { BudgetStatusEnum } from "../../../../enums/budgetStatus";

export enum BudgetRecipientEnum {
  CONSULTANT = "CONSULTANT",
  TOWER = "FACTORY",
  MANAGER = "MANAGER",
}

export interface IBudgetItem {
  ref: string;
  item: string;
  itemOptions?: Array<{ id: string; label: string }>;
  description: string;
  quantity: string;
  quantityOptions?: Array<{ id: string; label: string }>;
  value: number;
  discount: string;
  subtotal: number;
  removed?: boolean;
  isCovered?: boolean;
  notCoveredReason?: string;
}

export interface IFileItem {
  name: string;
  type?: string;
  size?: string | number;
  file?: File;
  link?: string;
  updatedAt?: string;
}

export interface IVehicleData {
  model?: string;
  year?: string;
  licensePlate?: string;
  chassis?: string;
  odometer?: string;
  hourmeter?: string;
  inWarranty?: boolean;
  protocolNumber?: string;
  contractNumber?: string;
}

export interface IClientData {
  name?: string;
  phone?: string;
  email?: string;
}

export interface IBudgetService {
  id?: string;
  ref: string;
  serviceId: string;
  serviceName?: string;
  serviceType: string;
  failureModeId?: string;
  items: IBudgetItem[];
  observation?: string;
  subtotal: number;
  clientPercentage?: number;
  volkstotalPercentage?: number;
  dealershipPercentage?: number;
  warrantyPercentage?: number;
  isExternalService?: boolean;
  percentages?: {
    customer: number;
    volkstok: number;
    dealership: number;
    warranty: number;
  };
}

export interface IBudgetSummary {
  subtotal: number;
  discounts: number;
  subscriptionBalanceApplied?: number;
  totalToPay: number;
  counterProposalValue?: number;
}

export interface IUserProfileData {
  sub?: string;
  azp?: string;
  account?: string;
  givenName?: string;
  familyName?: string;
  name?: string;
  locale?: string;
  email?: string;
}

export interface IBudgetFormData {
  occurrenceId: string;
  number: string;
  budgetId: string;
  budgetCreatedBy?: string;
  userProfile?: IUserProfileData;
  vehicleData?: IVehicleData;
  clientData?: IClientData;
  origin?: BudgetRecipientEnum | string;
  originUserName?: string;
  recipient?: BudgetRecipientEnum | string;
  services: IBudgetService[];
  proposalServices?: IBudgetService[];
  files?: IFileItem[];
  summary: IBudgetSummary;
  counterProposal?: boolean;
  counterProposalValue?: number;
  counterProposalObs?: string;
  profile?: BudgetRecipientEnum;
  status?: BudgetStatusEnum;
  rejectionObservation?: string;
  counterProposalSubStatus?: BudgetCounterProposalSubStatusEnum;
  counterProposalAcceptedAt?: string;
  observation?: string;
  versionNumber?: number;
  username?: string;
  consultant?: string;
  coverageBalance?: number;
  useCoverageBalance?: boolean;
  subscriptionBalanceToApply?: number;
}

export interface IBudgetServiceItem {
  ref: string;
  item: string;
  description: string;
  quantity: number;
  value: number;
  discount: number;
  subtotal: number;
  isCovered?: boolean;
}

export interface IBudgetServicePayload {
  ref: string;
  service: string;
  serviceType: string;
  description: string;
  items: Array<IBudgetServiceItem>;
  percentages: {
    customer: number;
    volkstok: number;
    dealership: number;
    warranty: number;
  };
  observation?: string;
  subtotal: number;
  discount: number;
  isExternalService?: boolean;
  failureMode?: string;
}

export interface IBudgetApiPayload {
  occurrenceProtocolNumber: string;
  occurrenceUuid: string;
  recipient: string;
  customer: {
    name: string;
    email: string;
    phone: string;
  };
  vehicle: {
    chassis?: string;
    licensePlate?: string;
    year: number;
    model?: string;
    odometer?: number;
    hourMeter?: number | null;
    contractNumber?: string | null;
  };
  services: Array<IBudgetServicePayload>;
  proposalServices?: Array<IBudgetServicePayload>;
  subtotal: number;
  discount: number;
  netTotal: number;
  observation?: string;
}
